import { Video } from './video'

class VideosList {

    constructor() {
    }
    init(){
        this.vidDomElements = document.querySelectorAll('[data-video]')
        this.videosArr = [];
        for (let i = 0; i < this.vidDomElements.length; i++) {
            this.videosArr.push(new Video(this.vidDomElements[i]));
        }
    }
}

const videos = new VideosList()

export { videos }

